import { useState } from 'react';
import { ScrollText, ChevronRight, Check } from 'lucide-react';
import { useI18n } from '../i18n';

export default function CommunityGuidelinesCard() {
    const { t } = useI18n();
    const [open, setOpen] = useState(false);
    const rules = ['guidelines.r1', 'guidelines.r2', 'guidelines.r3', 'guidelines.r4', 'guidelines.r5'];

    return (
        <section className="mb-8" data-testid="community-guidelines">
            <button
                data-testid="btn-toggle-guidelines"
                onClick={() => setOpen((o) => !o)}
                className="w-full flex items-center gap-4 bg-brand-card border border-brand-border rounded-2xl p-4 text-left hover:border-brand-green/50 transition-all"
            >
                <div className="w-11 h-11 rounded-2xl bg-brand-green/15 text-brand-green flex items-center justify-center flex-shrink-0">
                    <ScrollText size={20} strokeWidth={1.7} />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="font-serif text-base text-brand-ink">{t('guidelines.title')}</div>
                    <div className="text-xs text-brand-ink3 mt-0.5">{t('guidelines.sub')}</div>
                </div>
                <ChevronRight size={16} className={`text-brand-ink3 flex-shrink-0 transition-transform ${open ? 'rotate-90' : ''}`} />
            </button>
            {open && (
                <div className="mt-2 bg-brand-card border border-brand-border rounded-2xl p-4 space-y-2.5" data-testid="guidelines-body">
                    {rules.map((r) => (
                        <div key={r} className="flex items-start gap-2.5 text-sm text-brand-ink2">
                            <Check size={15} className="text-brand-green flex-shrink-0 mt-0.5" />
                            <span>{t(r)}</span>
                        </div>
                    ))}
                    <p className="text-[11px] text-brand-ink3 pt-2 border-t border-brand-border leading-relaxed">{t('guidelines.note')}</p>
                </div>
            )}
        </section>
    );
}
